import './footer.css'

import EnglishResourceBundle from './locale/footer.en.json'
import FrenchResourceBundle from './locale/footer.fr.json'
import React from 'react';
import { useTranslation } from 'react-i18next';

export const Footer = () => {
    const { t, i18n } = useTranslation();
    i18n.addResourceBundle('en', 'footer', EnglishResourceBundle);
    i18n.addResourceBundle('fr', 'footer', FrenchResourceBundle);

    return (
        <footer className="aform-footer py-3 no-print">
            <div className="row flex-nowrap justify-content-between align-items-center">
                <div className="col-12 d-flex justify-content-end align-items-center">                                
                    <ul className="list-inline">
                        <li className="list-inline-item">
                            <a href={t("footer:personalInformationHref")} target="_blank" rel="noopener noreferrer">{t("footer:personalInformation")}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
}